import axios from 'axios';
import { uri } from '../constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// Function to get all roles
export const getUserRoles = async () => {
  try {
    const response = await axios.get(`${uri}/roles`);
    return response.data.roles;
  } catch (error) {
    throw error;
  }
};

// Function to get a specific role by ID
export const getUserRole = async (roleId) => {
  try {
    const response = await axios.get(`${uri}/roles/${roleId}`);
    return response.data.role;
  } catch (error) {
    throw error;
  }
};

// Function to create a new role
export const createUserRole = async (roleData) => {
  try {
    const response = await axios.post(`${uri}/roles`, roleData);
    return response.data.role;
  } catch (error) {
    throw error;
  }
};

// Function to update an existing role
export const updateUserRole = async (roleId, roleData) => {
  try {
    const response = await axios.put(`${uri}/roles/${roleId}`, roleData);
    return response.data.role;
  } catch (error) {
    throw error;
  }
};

// Function to delete a role
export const deleteUserRole = async (roleId) => {
  try {
    const response = await axios.delete(`${uri}/roles/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// React Query mutations for role operations
export const useCreateUserRole = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (roleData) => createUserRole(roleData),
    onSuccess: () => {
      // Invalidate roles cache to refresh data
      queryClient.invalidateQueries({ queryKey: ['roles'] });
    },
  });
};

export const useUpdateUserRole = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ roleId, roleData }) => updateUserRole(roleId, roleData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
    },
  });
};

export const useDeleteUserRole = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (roleId) => deleteUserRole(roleId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
    },
  });
};
